module.exports = __webpack_public_path__ + "static/media/banner_below_image_3.22e1a937.svg";